export default "__VITE_PUBLIC_ASSET__26f14c3c__"